import { AuthSession, getCurrentUser } from 'aws-amplify/auth';
import { LDClient, LDContext, initialize } from 'launchdarkly-react-client-sdk';
import kebabCase from 'lodash/kebabCase';

import { getSession } from './session';

let ldClient: LDClient | null = null;

const initLDClient = async (): Promise<LDClient> => {
  if (!ldClient) {
    const context = await getLaunchDarklyContextFromSession();
    ldClient = initialize(import.meta.env.VITE_LAUNCH_DARKLY_CLIENT_SIDE_ID, context, { bootstrap: 'localStorage' });
    await ldClient.waitForInitialization();
  }
  return ldClient;
};

export async function getFlag(flagKey: string): Promise<boolean> {
  const client = await initLDClient();
  const kebabed = kebabCase(flagKey);
  return client.variation(kebabed, false);
}

const defaultContext: LDContext = {
  kind: 'user',
  anonymous: true,
};

export async function getLaunchDarklyContextFromSession(): Promise<LDContext> {
  let session: AuthSession;
  try {
    await getCurrentUser();
    session = await getSession();
  } catch {
    return defaultContext;
  }

  const userEmail = session.tokens?.idToken?.payload.email;
  const clientId = session.tokens?.idToken?.payload['custom:client_id'];
  if (typeof userEmail !== 'string' || typeof clientId !== 'string') {
    return defaultContext;
  }
  return {
    kind: 'user',
    key: userEmail,
    email: userEmail,
    clientId,
  };
}
